export const insertTextToDOM = (text: string) => {
  try {
    document.execCommand("insertText", false, text);
    return true;
  } catch (err) {
    // ignore: not supported by browser
  }
  return false;
};
